import { Toaster } from 'react-hot-toast'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
// import ActivityFeed from './components/ActivityFeed'  // Geçici kapatıldı - topbar'ı itiyor
import RunAIOSLayout from './components/layout/RunAIOSLayout'
import ErrorBoundary from './components/shared/ErrorBoundary'
import ProtectedRoute from './components/shared/ProtectedRoute'
import { AuthProvider } from './contexts/AuthContext'
import { WebSocketProvider } from './contexts/WebSocketContext'
import { ToastProvider } from './hooks/useToast'
// About, Help, Support, Terms, Privacy, FAQ → redirected to /ask-ai
import AgentDetail from './pages/AgentDetail'
import AgentEdit from './pages/AgentEdit'
import Agents from './pages/Agents'
import AgentsListing from './pages/AgentsListing'
import AskAI from './pages/AskAI'
import CloudIntegration from './pages/CloudIntegration'
import CreateAgent from './pages/CreateAgent'
import CreateProject from './pages/CreateProject'
import Discover from './pages/Discover'
import ElementList from './pages/ElementList'
import Esma from './pages/Esma'
import ExpertDetail from './pages/ExpertDetail'
import ExpertList from './pages/ExpertList'
// import FAQ from './pages/FAQ'
import FilizAI from './pages/FilizAI'
import FlzHubChat from './pages/FlzHub'
// import Help from './pages/Help'
import ForgotPassword from './pages/ForgotPassword'
import Home from './pages/Home'
import InvitationAccept from './pages/InvitationAccept'
import LandingPage from './pages/LandingPage'
import Leaderboard from './pages/Leaderboard'
import LLMConfig from './pages/LLMConfig'
import LLMOpenClawLocal from './pages/LLMOpenClawLocal'
import LLMRouter from './pages/LLMRouter'
import LLMSharedPool from './pages/LLMSharedPool'
import Login from './pages/Login'
import MyAgents from './pages/MyAgents'
import MyProjects from './pages/MyProjects'
import Notifications from './pages/Notifications'
import OSHomePage from './pages/os/OSHomePage'
import OSStatsPage from './pages/os/OSStatsPage'
import PetalsMining from './pages/PetalsMining'
import PostDetail from './pages/PostDetail'
import PricingPage from './pages/PricingPage'
import VerifyEmail from './pages/VerifyEmail'
// import Privacy from './pages/Privacy'
// _OLD: import Profile from './pages/Profile'
import ProjectDetail from './pages/ProjectDetail'
import Projects from './pages/Projects'
import ProjectsListing from './pages/ProjectsListing'
import ProjectWorkspace from './pages/ProjectWorkspace'
import Register from './pages/Register'
import Research from './pages/Research'
import ResearchDetail from './pages/ResearchDetail'
import Settings from './pages/Settings'
import SkillsMarketplace from './pages/SkillsMarketplace'
import SocialFeed from './pages/SocialFeed'
import SocialFollowing from './pages/SocialFollowing'
import SocialSaved from './pages/SocialSaved'
import SocialTopics from './pages/SocialTopics'
import StoreTest from './pages/StoreTest'
import WikiPage from './pages/WikiPage'
// import Support from './pages/Support'
import Tasks from './pages/Tasks'
// import Terms from './pages/Terms'
import Billing from './pages/Billing'
import Onboarding from './pages/Onboarding'
import Organization from './pages/Organization'
import ThemeDemo from './pages/ThemeDemo'
import Tokenomics from './pages/Tokenomics'
import AWSTutorial from './pages/tutorials/AWSTutorial'
import AzureTutorial from './pages/tutorials/AzureTutorial'
import CloudflareTutorial from './pages/tutorials/CloudflareTutorial'
import GCPTutorial from './pages/tutorials/GCPTutorial'
import GDriveTutorial from './pages/tutorials/GDriveTutorial'
import OneDriveTutorial from './pages/tutorials/OneDriveTutorial'
import PublicPortfolio from './pages/PublicPortfolio'
import UserProfile from './pages/UserProfile'
import Wallet from './pages/Wallet'
import Work from './pages/Work'
import WorkCategories from './pages/WorkCategories'
import WorkCreate from './pages/WorkCreate'
import WorkDetail from './pages/WorkDetail'
import { AppProvider } from './store/useAppStore'

// Wrapper component for ErrorBoundary per route
const RouteWithErrorBoundary = ({ children }: { children: React.ReactNode }) => (
  <ErrorBoundary>{children}</ErrorBoundary>
)

export default function App() {
  return (
    <AuthProvider>
    <AppProvider>
    <WebSocketProvider>
    <ToastProvider>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      {/* <ActivityFeed /> */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'var(--card-bg)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border-color)',
            borderRadius: '12px',
            padding: '16px',
            fontSize: '14px',
            fontWeight: '500',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<RouteWithErrorBoundary><LandingPage /></RouteWithErrorBoundary>} />
        <Route path="/pricing" element={<RouteWithErrorBoundary><PricingPage /></RouteWithErrorBoundary>} />
        <Route path="/home" element={<RouteWithErrorBoundary><Home /></RouteWithErrorBoundary>} />
        <Route path="/filizai" element={<RouteWithErrorBoundary><FilizAI /></RouteWithErrorBoundary>} />
        <Route path="/login" element={<RouteWithErrorBoundary><Login /></RouteWithErrorBoundary>} />
        <Route path="/register" element={<RouteWithErrorBoundary><Register /></RouteWithErrorBoundary>} />
        <Route path="/forgot-password" element={<RouteWithErrorBoundary><ForgotPassword /></RouteWithErrorBoundary>} />
        <Route path="/reset-password" element={<RouteWithErrorBoundary><ForgotPassword /></RouteWithErrorBoundary>} />
        <Route path="/verify-email" element={<RouteWithErrorBoundary><VerifyEmail /></RouteWithErrorBoundary>} />
        <Route path="/help" element={<Navigate to="/ask-ai" replace />} />
        <Route path="/invitations/:token/accept" element={<RouteWithErrorBoundary><InvitationAccept /></RouteWithErrorBoundary>} />
        <Route path="/faq" element={<Navigate to="/ask-ai" replace />} />
        <Route path="/about" element={<Navigate to="/ask-ai" replace />} />
        <Route path="/support" element={<Navigate to="/ask-ai" replace />} />
        <Route path="/terms" element={<Navigate to="/ask-ai" replace />} />
        <Route path="/privacy" element={<Navigate to="/ask-ai" replace />} />
        <Route path="/tokenomics" element={<RouteWithErrorBoundary><Tokenomics /></RouteWithErrorBoundary>} />
        <Route path="/store-test" element={<RouteWithErrorBoundary><StoreTest /></RouteWithErrorBoundary>} />
        <Route path="/theme-demo" element={<RouteWithErrorBoundary><ThemeDemo /></RouteWithErrorBoundary>} />
        <Route path="/onboarding" element={<ProtectedRoute><RouteWithErrorBoundary><Onboarding /></RouteWithErrorBoundary></ProtectedRoute>} />

        {/* Public - Kesfet */}
        <Route path="/discover" element={<RouteWithErrorBoundary><Discover /></RouteWithErrorBoundary>} />
        <Route path="/projects" element={<RouteWithErrorBoundary><Projects /></RouteWithErrorBoundary>} />
        <Route path="/work" element={<RouteWithErrorBoundary><Work /></RouteWithErrorBoundary>} />
        <Route path="/work/create" element={<ProtectedRoute><RouteWithErrorBoundary><WorkCreate /></RouteWithErrorBoundary></ProtectedRoute>} />
        <Route path="/work/categories" element={<RouteWithErrorBoundary><WorkCategories /></RouteWithErrorBoundary>} />
        <Route path="/work/:taskId" element={<ProtectedRoute><RouteWithErrorBoundary><WorkDetail /></RouteWithErrorBoundary></ProtectedRoute>} />
        <Route path="/projects-listing" element={<RouteWithErrorBoundary><ProjectsListing /></RouteWithErrorBoundary>} />
        <Route path="/agents" element={<RouteWithErrorBoundary><Agents /></RouteWithErrorBoundary>} />
        <Route path="/agents-listing" element={<RouteWithErrorBoundary><AgentsListing /></RouteWithErrorBoundary>} />
        <Route path="/ask-ai" element={<RouteWithErrorBoundary><AskAI /></RouteWithErrorBoundary>} />
        <Route path="/social" element={<RouteWithErrorBoundary><SocialFeed /></RouteWithErrorBoundary>} />
        <Route path="/social/topics" element={<RouteWithErrorBoundary><SocialTopics /></RouteWithErrorBoundary>} />
        <Route path="/social/following" element={<RouteWithErrorBoundary><SocialFollowing /></RouteWithErrorBoundary>} />
        <Route path="/social/saved" element={<RouteWithErrorBoundary><SocialSaved /></RouteWithErrorBoundary>} />
        <Route path="/social/post/:postId" element={<RouteWithErrorBoundary><PostDetail /></RouteWithErrorBoundary>} />
        <Route path="/flzhub" element={<ProtectedRoute requireAdmin={true}><RouteWithErrorBoundary><FlzHubChat /></RouteWithErrorBoundary></ProtectedRoute>} />
        <Route path="/flzhub/chat" element={<Navigate to="/flzhub" replace />} />
        <Route path="/cloud" element={<RouteWithErrorBoundary><CloudIntegration /></RouteWithErrorBoundary>} />
        <Route path="/cloud/tutorial/cloudflare" element={<RouteWithErrorBoundary><CloudflareTutorial /></RouteWithErrorBoundary>} />
        <Route path="/cloud/tutorial/aws" element={<RouteWithErrorBoundary><AWSTutorial /></RouteWithErrorBoundary>} />
        <Route path="/cloud/tutorial/gcp" element={<RouteWithErrorBoundary><GCPTutorial /></RouteWithErrorBoundary>} />
        <Route path="/cloud/tutorial/azure" element={<RouteWithErrorBoundary><AzureTutorial /></RouteWithErrorBoundary>} />
        <Route path="/cloud/tutorial/gdrive" element={<RouteWithErrorBoundary><GDriveTutorial /></RouteWithErrorBoundary>} />
        <Route path="/cloud/tutorial/onedrive" element={<RouteWithErrorBoundary><OneDriveTutorial /></RouteWithErrorBoundary>} />
        <Route path="/petals-mining" element={<RouteWithErrorBoundary><PetalsMining /></RouteWithErrorBoundary>} />
        <Route path="/experts" element={<RouteWithErrorBoundary><ExpertList /></RouteWithErrorBoundary>} />
        <Route path="/esma" element={<RouteWithErrorBoundary><Esma /></RouteWithErrorBoundary>} />
        <Route path="/elements" element={<RouteWithErrorBoundary><ElementList /></RouteWithErrorBoundary>} />
        <Route path="/leaderboard" element={<RouteWithErrorBoundary><Leaderboard /></RouteWithErrorBoundary>} />
        <Route path="/tasks" element={<RouteWithErrorBoundary><Tasks /></RouteWithErrorBoundary>} />
        <Route path="/research" element={<RouteWithErrorBoundary><Research /></RouteWithErrorBoundary>} />
        <Route path="/wiki" element={<RouteWithErrorBoundary><WikiPage /></RouteWithErrorBoundary>} />
        <Route path="/wiki/:id" element={<RouteWithErrorBoundary><WikiPage /></RouteWithErrorBoundary>} />
        {/* Public - Detay Sayfalari */}
        <Route path="/research/:id" element={<RouteWithErrorBoundary><ResearchDetail /></RouteWithErrorBoundary>} />
        <Route path="/work/:id" element={<RouteWithErrorBoundary><ProjectDetail /></RouteWithErrorBoundary>} />
        <Route path="/project/:projectId/workspace" element={<RouteWithErrorBoundary><ProjectWorkspace /></RouteWithErrorBoundary>} />
        <Route path="/agent/:id" element={<RouteWithErrorBoundary><AgentDetail /></RouteWithErrorBoundary>} />
        <Route path="/experts/:expertId" element={<RouteWithErrorBoundary><ExpertDetail /></RouteWithErrorBoundary>} />
        <Route path="/profile/:username" element={<RouteWithErrorBoundary><UserProfile /></RouteWithErrorBoundary>} />
        <Route path="/user/:userId" element={<RouteWithErrorBoundary><UserProfile /></RouteWithErrorBoundary>} />
        <Route path="/u/:username" element={<RouteWithErrorBoundary><PublicPortfolio /></RouteWithErrorBoundary>} />

        {/* /old_dashboard → eski RunAI OS dashboard (yeni sistem /dashboard'a taşındı) */}
        <Route path="/old_dashboard" element={
          <ProtectedRoute>
            <RouteWithErrorBoundary><RunAIOSLayout /></RouteWithErrorBoundary>
          </ProtectedRoute>
        }>
          <Route index element={<OSHomePage />} />
          <Route path="stats" element={<OSStatsPage />} />
          <Route path="billing" element={<Billing />} />
          {/* All other /old_dashboard/* routes → WebOS handles via window system */}
          <Route path="*" element={<OSHomePage />} />
        </Route>
        {/* /dashboard → yeni WebOS (RunAI_WebOS) */}
        <Route path="/dashboard" element={<Navigate to="/dashboard" replace />} />
        <Route
          path="/user-panel"
          element={<Navigate to="/old_dashboard" replace />}
        />
        <Route
          path="/profile"
          element={<Navigate to="/old_dashboard/settings" replace />}
        />
        <Route
          path="/profile/"
          element={<Navigate to="/old_dashboard/settings" replace />}
        />
        {/* Classic aicloud → old_dashboard redirect */}
        <Route path="/aicloud/*" element={<Navigate to="/old_dashboard" replace />} />
        <Route
          path="/my-projects"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <MyProjects />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/my-agents"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <MyAgents />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/create-project"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <CreateProject />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/projects/create"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <CreateProject />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/create-agent"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <CreateAgent />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/agents/create"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <CreateAgent />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/agents/:id/edit"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <AgentEdit />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/project/:id/edit"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <CreateProject />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/projects/:id/edit"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <CreateProject />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/wallet"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <Wallet />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/notifications"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/settings"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/org"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <Organization />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/org/:orgId"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <Organization />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/llm-config"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <LLMConfig />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/llm-shared-pool"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <LLMSharedPool />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/llm-openclaw-local"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <LLMOpenClawLocal />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/llm-router"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <LLMRouter />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/skills-marketplace"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <SkillsMarketplace />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />



        {/* Admin routes — tamamen kaldırıldı, WebOS Dock'tan açılır */}

        {/* 404 — Catch all */}
        <Route path="*" element={
          <RouteWithErrorBoundary>
            <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'var(--body-bg)', color: 'var(--text-primary)', fontFamily: 'inherit', overflow: 'hidden', position: 'relative' }}>
              {/* Animated background */}
              <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 20% 50%, rgba(99,102,241,0.15) 0%, transparent 50%), radial-gradient(ellipse at 80% 20%, rgba(236,72,153,0.1) 0%, transparent 50%)', pointerEvents: 'none' }} />

              {/* Animated 404 */}
              <div style={{ position: 'relative', marginBottom: 8 }}>
                <div style={{
                  fontSize: 'clamp(80px, 20vw, 180px)', fontWeight: 900, lineHeight: 1,
                  background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #ec4899 100%)',
                  WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  filter: 'drop-shadow(0 0 40px rgba(99,102,241,0.4))',
                  animation: 'float404 3s ease-in-out infinite',
                }}>
                  404
                </div>
                {/* Glitch effect lines */}
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #ec4899 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', fontSize: 'clamp(80px, 20vw, 180px)', fontWeight: 900, lineHeight: 1, opacity: 0.3, animation: 'glitch404 4s infinite', clipPath: 'polygon(0 30%, 100% 30%, 100% 50%, 0 50%)' }}>
                  404
                </div>
              </div>

              <div style={{ fontSize: 'clamp(18px, 3vw, 28px)', fontWeight: 700, marginBottom: 12, textAlign: 'center' }}>
                Looks like you're lost
              </div>
              <div style={{ fontSize: 14, color: 'var(--text-secondary)', maxWidth: 380, textAlign: 'center', lineHeight: 1.7, marginBottom: 32, padding: '0 20px' }}>
                The page you're looking for doesn't exist or has been moved to another dimension.
              </div>

              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center', padding: '0 20px' }}>
                <a href="/" style={{ padding: '12px 24px', background: 'linear-gradient(135deg, #6366f1, #a855f7)', color: '#fff', borderRadius: 12, textDecoration: 'none', fontSize: 14, fontWeight: 700, boxShadow: '0 4px 20px rgba(99,102,241,0.4)' }}>
                  ← Go Home
                </a>
                <a href="/dashboard" style={{ padding: '12px 24px', background: 'rgba(99,102,241,0.1)', color: '#818cf8', border: '1px solid rgba(99,102,241,0.3)', borderRadius: 12, textDecoration: 'none', fontSize: 14, fontWeight: 600 }}>
                  Open Dashboard
                </a>
                <a href="/ask-ai" style={{ padding: '12px 24px', background: 'transparent', color: 'var(--text-secondary)', border: '1px solid var(--border-color)', borderRadius: 12, textDecoration: 'none', fontSize: 14, fontWeight: 600 }}>
                  Get Help
                </a>
              </div>

              <style>{`
                @keyframes float404 {
                  0%, 100% { transform: translateY(0px); }
                  50% { transform: translateY(-12px); }
                }
                @keyframes glitch404 {
                  0%, 90%, 100% { transform: translate(0); opacity: 0; }
                  92% { transform: translate(-4px, 2px); opacity: 0.4; }
                  94% { transform: translate(4px, -2px); opacity: 0.2; }
                  96% { transform: translate(-2px, 0); opacity: 0.3; }
                }
              `}</style>
            </div>
          </RouteWithErrorBoundary>
        } />
      </Routes>
    </BrowserRouter>
    </ToastProvider>
    </WebSocketProvider>
    </AppProvider>
    </AuthProvider>
  )
}
